/**
 * @file Item de navigation desktop du header public (pastille dans la pilule de nav).
 * @module packages.common.layouts.public.components.HeaderNavItem
 *
 * Entrée du menu desktop : libellé + icône optionnelle, posés dans la pilule
 * de navigation. Au survol (ou à l'état actif, ex. menu catégories ouvert),
 * l'entrée devient une pastille blanche surélevée et le texte prend la
 * couleur de l'établissement.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography} from '@mui/material';

const HeaderNavItem = ({label, onClick, primaryColor, icon = null, endIcon = null, isActive = false}) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    }}
  >
    <Typography
      component="span"
      sx={{
        'display': 'flex',
        'alignItems': 'center',
        'gap': icon || endIcon ? 0.75 : 0,
        'px': {md: 1.75, lg: 2.25},
        'py': 1,
        'borderRadius': 999,
        'fontSize': {md: '0.85rem', lg: '0.9rem'},
        'fontWeight': 500,
        'letterSpacing': '0.02em',
        'whiteSpace': 'nowrap',
        'color': isActive ? primaryColor : 'text.primary',
        'backgroundColor': isActive ? 'background.paper' : 'transparent',
        'boxShadow': isActive ? '0 2px 10px rgba(0, 0, 0, 0.08)' : 'none',
        'transition': 'color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          color: primaryColor,
          backgroundColor: 'background.paper',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
        },
      }}
    >
      {icon}
      {label}
      {endIcon}
    </Typography>
  </Box>
);

HeaderNavItem.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  primaryColor: PropTypes.string.isRequired,
  icon: PropTypes.node,
  endIcon: PropTypes.node,
  isActive: PropTypes.bool,
};

export default HeaderNavItem;
